import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';

const styles = () => ({
  container: {
    margin: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },

  title: {
    fontSize: '18px',
    lineHeight: '22px',
  },

  subheading: {
    marginTop: '14px',
    lineHeight: '24px'
  },
});

const ResultEmptySection = props => {
  const { classes } = props;
  return (
    <div className={classes.container}>
      <Typography variant="display1" className={classes.title}>ダウンロード履歴はありません。</Typography>
      <Typography variant="body2" className={classes.subheading}>
        エクスポートを行うと、ここに履歴が表示されます。
      </Typography>
    </div>
  );
}

ResultEmptySection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ResultEmptySection);



// WEBPACK FOOTER //
// ./src/components/DownloadHistory/sections/ResultEmptySection.jsx